const ITEMS = [
    "Transporte Rodoviário",
    "Inertes",
    "Betuminosos",
    "Água",
    "Equipamentos",
    "Mercadorias",
    "Todo o Território Nacional",
    "Desde 1998",
];

export const Marquee = () => (
    <div
        className="relative overflow-hidden border-y border-white/10 bg-ink py-6"
        data-testid="editorial-marquee"
        aria-hidden="true"
    >
        <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
            {[...ITEMS, ...ITEMS].map((item, i) => (
                <div key={i} className="flex items-center gap-10">
                    <span
                        className={`font-display text-3xl font-black uppercase tracking-tight sm:text-4xl ${
                            i % 2 === 0 ? "text-white" : "text-outline"
                        }`}
                    >
                        {item}
                    </span>
                    <span className="h-2.5 w-2.5 rotate-45 bg-brand" />
                </div>
            ))}
        </div>
    </div>
);
